import React, { useEffect, useState, useRef } from "react";

import { makeStyles } from "@material-ui/core";

import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import { FormControlLabel } from "@material-ui/core";
import Checkbox from "@material-ui/core/Checkbox";
import Box from "@material-ui/core/Box";
import { useTheme } from "@material-ui/core/styles";
import Modal from "@material-ui/core/Modal";
import Dialog from "@material-ui/core/Dialog";

import Button from "@material-ui/core/Button";

const elementSytle = {
  width: "90%",
};
const boxWidth = 500;
const boxMarginLeft = 10;
const boxMarginTop = 5;
const useStyles = makeStyles((theme) => ({
  root: {
    "& > *": {
      margin: theme.spacing(1),
    },
  },
  margin: {
    margin: theme.spacing(1),
  },
  withoutLabel: {
    marginTop: theme.spacing(3),
  },
  textField: {
    width: "25ch",
  },
  boxStyle: {
    minWidth: boxWidth,
    marginTop: boxMarginTop,
  },
}));

function AddCourseDialog({
  okCallback,
  updateCallback,
  deleteCallback,
  cancelCallback,
  updateFlag,
  row,
  visible,
  language,
}) {
  const width = 600;

  const [name, setName] = useState(() => {
    if (row.name) {
      return row.name;
    } else {
      return "";
    }
  });
  const [description, setdescription] = useState(() => {
    if (row.name) {
      return row.description;
    } else {
      return "";
    }
  });
  const [availWeb, setAvailWeb] = useState(() => {
    if (row.name) {
      return row.availWeb;
    } else {
      return false;
    }
  });
  const [availMobile, setAvailMobile] = useState(() => {
    if (row.name) {
      return row.availMobile;
    } else {
      return false;
    }
  });


  useEffect(() => {}, []);

  const classes = useStyles();
  const theme = useTheme();

  const handleAdd = () => {
    if (
      description == "" ||
      name == "" ||
      name == undefined ||
      description == undefined
    ) {
      alert("Please enter all fields.");
    } else {
      const data = {
        name,
        language,
        availWeb,
        availMobile,
        id: language+name,
        description: description,
      };
      okCallback(data);
    }
  };

  const handleCancel = () => {
    cancelCallback();
  };
  const handleUpdate = () => {
    if (
      description == "" ||
      name == "" ||
      language == "" ||
      name == undefined ||
      language == undefined ||
      description == undefined
    ) {
      alert("Please enter all fields.");
    } else {
      const data = {
        name,
        language,
        id: language+name,
        availWeb,
        availMobile,
        description: description,
        
      };
      updateCallback(data);
    }
  };
  const handleDelete = () => {
    const data = {
      name,
      language,
      id: name,
      availWeb,
        availMobile,
      description: description,
    };
    deleteCallback(data);
  };

  const style = {
    display: "flex",
    flexDirection: "column",
    bgcolor: "#727981",
    justifyContent: "flex-start",
    alignItems: "center",
    width: "100%",
  };

  return (
    // <div className={classes.root}>
    <Dialog style={style} open={visible} onClose={cancelCallback}>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "flex-start",
          alignItems: "center",
          marginTop: 5,
          height: "90vh",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            width: width,
          }}
        >
          <Box sx={{ minWidth: boxWidth, marginTop: boxMarginTop }}>
            <TextField
              style={{ width: "100%" }}
              id="name"
              label="NAME"
              value={name}
              disabled={updateFlag}
              InputProps={{
                disableUnderline: false,
                margin: "dense",
              }}
              onChange={(e) => {
                setName(e.target.value);
              }}
              InputLabelProps={{ shrink: true }}
            ></TextField>
          </Box>
          <Box sx={{ minWidth: boxWidth, marginTop: boxMarginTop }}>
          </Box>
          <Box sx={{ minWidth: boxWidth, marginTop: boxMarginTop }}>
            <TextField
              style={{ width: "100%" }}
              id="description"
              label="description"
              value={description}
              InputProps={{
                disableUnderline: false,
                margin: "dense",
              }}
              onChange={(e) => {
                setdescription(e.target.value);
              }}
              InputLabelProps={{ shrink: true }}
            ></TextField>
          </Box>
          <Box sx={{ minWidth: boxWidth, marginTop: boxMarginTop }}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={availWeb}
                  onChange={(e) => {
                    setAvailWeb(e.target.checked);
                  }}
                />
              }
              label="AVAILABLE WEB "
            />
          </Box>
          <Box sx={{ minWidth: boxWidth, marginTop: boxMarginTop }}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={availMobile}
                  onChange={(e) => {
                    setAvailMobile(e.target.checked);
                  }}
                />
              }
              label="AVAILABLE MOBILE "
            />
          </Box>
        </div>

        {updateFlag ? (
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-evenly",
              alignItems: "center",
              width: "90%",
            }}
          >
            <Button
              style={{
                backgroundColor: "#379683",
                color: "white",
                marginTop: 5,
                marginBottom: 5,
                // width: 40,
              }}
              onClick={handleUpdate}
            >
              UPDATE
            </Button>
            <Button
              style={{
                backgroundColor: "red",
                color: "white",
                marginTop: 5,
                marginBottom: 5,
                width: 40,
              }}
              onClick={handleDelete}
            >
              DELETE
            </Button>
            <Button
              style={{
                backgroundColor: "#379683",
                color: "white",
                marginTop: 5,
                marginBottom: 5,
                width: 40,
              }}
              onClick={handleCancel}
            >
              CANCEL
            </Button>
          </div>
        ) : (
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-evenly",
              alignItems: "center",
              width: "90%",
            }}
          >
            <Button
              style={{
                backgroundColor: "#379683",
                color: "white",
                marginTop: 5,
                marginBottom: 5,
                width: 40,
              }}
              onClick={handleAdd}
            >
              ADD
            </Button>
            <Button
              style={{
                backgroundColor: "#379683",
                color: "white",
                marginTop: 5,
                marginBottom: 5,
                width: 40,
              }}
              onClick={handleCancel}
            >
              CANCEL
            </Button>
          </div>
        )}
      </div>
    </Dialog>
  );
}

export default AddCourseDialog;
